export default class ShopFooter extends HTMLElement {
  constructor() {
    super()
  }
}

customElements.define('shop-footer', ShopFooter)
